import { useMutation } from "@tanstack/react-query";
import { IUpdateUserSubscriptionCancellationReasonModel } from "../../models/UserSubscription";
import { UserSubscriptionService } from "../../services/userSubscription.service";

export const useUserSubscriptionCancellationReasonMutations = () => {
  const { mutate: updateCancellationReason } = useMutation<
    {},
    Error,
    { userSubscriptionId: string; model: IUpdateUserSubscriptionCancellationReasonModel }
  >({
    mutationFn: ({ userSubscriptionId, model }) => {
      return UserSubscriptionService.updateUserSubscriptionCancellationReason(
        userSubscriptionId,
        model
      ).then((res) => res.data);
    },
  });

  return {
    updateCancellationReason,
  };
};
